/**
 * LavorazioneDashboard — autenticazione Phase 6 (IMPL-P6-007).
 *
 * Placeholder landing for OPERATOR users. Wrapped in
 * `RequireAuth roles={['OPERATOR']}` so anonymous visitors are redirected
 * to `/accedi?redirectTo=/lavorazione` and non-OPERATOR roles are bounced
 * to `/`.
 */
import { AppLayout } from '@/components/layout/AppLayout';
import { RequireAuth } from '@/features/auth/components/RequireAuth';

export function LavorazioneDashboard() {
  return (
    <RequireAuth roles={['OPERATOR']}>
      <AppLayout>
        <section className="space-y-3">
          <h1 className="text-3xl font-semibold tracking-tight">Dashboard Operatore</h1>
          <p className="text-muted-foreground">Sezione in arrivo nei prossimi sprint.</p>
        </section>
      </AppLayout>
    </RequireAuth>
  );
}
